<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <table mat-table [dataSource]="steps()" class="mat-elevation-z8" cdkDropList [cdkDropListData]="steps()" (cdkDropListDropped)="onStateDrop($event)">
                <ng-container matColumnDef="order">
                    <th mat-header-cell *matHeaderCellDef class="drag-column"></th>
                    <td mat-cell *matCellDef="let element" class="drag-column">
                        <fa-icon cdkDragHandle [ngClass]="{ 'drag-handle': true }" [icon]="faGripLinesVertical"></fa-icon>
                    </td>
                </ng-container>
                <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

                <!-- Colonne 'Nom' -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="column-name">Nom</th>
                    <td mat-cell *matCellDef="let element" class="column-name">{{ element.data.stepName }}</td>
                </ng-container>

                <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag cdkDragPreview [cdkDragData]="row" class="element-row"></tr>
            </table>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Appliquer</button>
    </mat-card-actions>
</mat-card>
